import React from 'react';
import styled from 'styled-components';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import colors from 'utils/colors';
import map from 'lodash/map';
import join from 'lodash/join';
import Loading from 'components/loading';
import { NonIdealState } from '@blueprintjs/core';
import {
  ResultsData,
  ResultsHoverTableRow,
  Table,
  ResultsHeaderRow,
  ResultsHeader,
  TableData,
} from 'components/styled-components';
import shortid from 'shortid';
import moment from 'moment';

const fields = [
  'Assessment ID',
  'Product / Service & Dept',
  'Assessment Created Date',
  'Status',
  'Approval Date',
  'Sponsor Name & Email',
  'Document Uploaded',
];

const MappedTable = ({ data, history }) =>
  map(data, (d, i) => (
    <ResultsHoverTableRow
      key={`${i}-${shortid.generate()}`}
      onClick={() => history.push(`/assessments/${d.vendorRequestID}`)}
    >
      <TableDataWithHeaders>{d.vendorRequestID}</TableDataWithHeaders>
      <TableDataWithHeaders>
        <div>{d.productServiceName}</div>

        <MutedText>{join(d.departmentsRequesting, ', ')}</MutedText>
      </TableDataWithHeaders>
      <TableDataWithHeaders>
        {' '}
        {moment(d.requestSubmittedDate).isValid()
          ? moment(d.requestSubmittedDate).format('MM/DD/YYYY')
          : 'N/A'}
      </TableDataWithHeaders>
      <TableDataWithHeaders>
        <div>{d.requestStatus}</div>
      </TableDataWithHeaders>
      <TableDataWithHeaders>
        {moment(d.approvalDate).isValid()
          ? moment(d.approvalDate).format('MM/DD/YYYY')
          : 'N/A'}
      </TableDataWithHeaders>
      <TableDataWithHeaders>
        <div>
          {d.sponsorInformation && d.sponsorInformation.firstName}{' '}
          {d.sponsorInformation && d.sponsorInformation.lastName}
        </div>
        {d.sponsorInformation && d.sponsorInformation.email}
      </TableDataWithHeaders>
      <TableDataWithHeaders>
        {d.documentUploaded ? 'Yes' : 'No'}
      </TableDataWithHeaders>
    </ResultsHoverTableRow>
  ));

const Requests = ({ requests, loading, history }) => {
  if (loading) {
    return <Loading />;
  }
  return (
    <Container>
      <DrawerHeader>Assessments</DrawerHeader>
      <Table>
        <tbody>
          <ResultsHeaderRow>
            {fields.map(field => (
              <ResultsHeader key={field}>{field}</ResultsHeader>
            ))}
          </ResultsHeaderRow>
          {requests.result ? (
            <MappedTable data={requests.result} history={history} />
          ) : (
            <tr>
              <TableData colSpan={fields.length}>
                <NonIdealState
                  icon="error"
                  title="No assessments could be found"
                  description="The system did not find any Assessments associated with this Third Party."
                  action={
                    <Link to="/manage-parties">
                      Back to Third Party Management
                    </Link>
                  }
                />
              </TableData>
            </tr>
          )}
        </tbody>
      </Table>
    </Container>
  );
};

const Container = styled.div`
  border-radius: 3px;
  flex-basis: 45%;
  flex-grow: 1;
  margin: 1rem;
  border: 1px solid ${colors.muted};
`;

const DrawerHeader = styled.div`
  width: 100%;
  border-bottom: 1px solid ${colors.muted};
  border-radius: 5px 5px 0px 0px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  font-size: 1rem;
  font-weight: 500;
  background-color: #fff;
`;

const MutedText = styled.span`
  color: ${colors.lightGray};
`;

const TableDataWithHeaders = styled(ResultsData)`
  @media only screen and (max-width: 760px),
    (min-width: 761px) and (max-width: 1024px) {
    /*
	Label the data
	*/
    &:nth-of-type(1):before {
      content: 'Assessment ID';
    }
    &:nth-of-type(2):before {
      content: 'Product / Service & Dept';
    }
    &:nth-of-type(3):before {
      content: 'Assessment Created Date';
    }
    &:nth-of-type(4):before {
      content: 'Status';
    }
    &:nth-of-type(5):before {
      content: 'Approval Date';
    }
    &:nth-of-type(6):before {
      content: 'SponsorName & Email';
    }
    &:nth-of-type(7):before {
      content: 'Document Uploaded';
    }
  }
`;

export default withRouter(Requests);
